import React from 'react';
import { Check, Phone } from 'lucide-react';
import { SlideFrame } from '../deck/SlideFrame';
export function AllDoneSlide() {
  return <SlideFrame tone="dark" data-id="element-183" data-mp="6kivkiifbypz">
      <div className="flex h-full flex-col items-center justify-center text-center" data-id="element-184" data-mp="6ksh9twfrjpv">
        <span className="flex h-[6cqw] w-[6cqw] items-center justify-center bg-mm-orange" data-id="element-185" data-mp="3ouuhc6xtldsy">
          <Check className="h-[3.6cqw] w-[3.6cqw] text-mm-black" strokeWidth={3} aria-hidden="true" data-id="element-186" data-mp="3twa4c4jk5udz" />
        </span>
        <h2 className="mt-[2.4cqw] font-heading text-[6.4cqw] font-bold leading-none tracking-tight text-mm-white" data-id="element-187" data-mp="ledyl7vwett9">
          You're all done!
        </h2>
        <p className="mt-[2cqw] max-w-[58cqw] font-body text-[1.8cqw] leading-[1.4] text-mm-light-gray" data-id="element-188" data-mp="bh966qbgm240">
          Thank you, Carolyn. Leslie Outreach is now set up to receive donations through Stripe.
        </p>
        <p className="mt-[1.4cqw] max-w-[58cqw] font-body text-[1.8cqw] leading-[1.4] text-mm-white" data-id="element-189" data-mp="2w6owlk6rnot4">
          Please reach out when all this is completed and I'll wire up everything on the website
          to accept donations ASAP.
        </p>
        <div className="mt-[2.8cqw] h-[0.25cqw] w-[8cqw] bg-mm-orange" aria-hidden="true" data-id="element-190" data-mp="20do3zo6kvob3" />
        <p className="mt-[2.4cqw] flex items-center gap-[1.2cqw] font-heading text-[3cqw] font-bold text-mm-orange" data-id="element-191" data-mp="2ed5tk5rp75li">
          <Phone className="h-[2.6cqw] w-[2.6cqw]" aria-hidden="true" data-id="element-192" data-mp="29djgpxfs7rd8" />
          Questions? Text or call Tim. :-)
        </p>
      </div>
    </SlideFrame>;
}